import { Shield, FileText, Receipt, Building2, Server, ShieldCheck, Cloud, Headphones, Package, Coffee, Apple, Shirt, Gift, UtensilsCrossed, Users, ClipboardList, HardHat, UserCheck, Award } from "lucide-react";

export const SERVICE_CATEGORIES = [
  {
    id: "compliance",
    title: "Compliance Services",
    desc: "End-to-end regulatory compliance so you stay audit-ready and penalty-free.",
    icon: Shield,
    route: "/services/compliance",
    accent: "#4f46e5",
  },
  {
    id: "it",
    title: "IT Services",
    desc: "Enterprise-grade technology solutions to power your digital transformation.",
    icon: Server,
    route: "/services/it",
    accent: "#16a34a",
  },
  {
    id: "supplies",
    title: "Business Supplies",
    desc: "Everything your workplace needs — delivered on time, every time.",
    icon: Package,
    route: "/services/supplies",
    accent: "#ea580c",
  },
  {
    id: "manpower",
    title: "Manpower Solutions",
    desc: "Flexible staffing and workforce management tailored to your business.",
    icon: Users,
    route: "/services/manpower",
    accent: "#2563eb",
  },
];

export const COMPLIANCE_SERVICES = [
  {
    icon: FileText,
    title: "Accounting Services",
    slug: "accounting",
    accentColor: "#6366f1",
    desc: "Comprehensive accounting solutions — bookkeeping, financial statements, and payroll processing.",
    features: ["Monthly Bookkeeping", "Financial Statements", "Payroll Processing", "Budget Planning"],
    stat: "99.8%",
    statLabel: "Accuracy",
  },
  {
    icon: Receipt,
    title: "GST Filing",
    slug: "gst-filing",
    accentColor: "#10b981",
    desc: "Hassle-free GST compliance with timely filing and expert tax optimization guidance.",
    features: ["GST Registration", "Monthly/Quarterly Returns", "Input Tax Credit", "Compliance Audit"],
    stat: "48h",
    statLabel: "Turnaround",
  },
  {
    icon: ClipboardList,
    title: "Income Tax",
    slug: "income-tax",
    accentColor: "#8b5cf6",
    desc: "Expert tax filing for individuals and businesses — maximizing deductions, ensuring compliance.",
    features: ["ITR Filing", "Tax Planning", "Refund Processing", "Notice Handling"],
    stat: "30%",
    statLabel: "Savings",
  },
  {
    icon: Building2,
    title: "MCA Compliance",
    slug: "mca-compliance",
    accentColor: "#f59e0b",
    desc: "Complete corporate compliance to keep your business aligned with MCA regulations.",
    features: ["Annual Filing", "Board Resolutions", "Statutory Registers", "ROC Compliance"],
    stat: "100%",
    statLabel: "On-Time",
  },
];

export const IT_SERVICES = [
  {
    icon: Server,
    title: "Managed IT",
    slug: "managed-it",
    accentColor: "#16a34a",
    desc: "24/7 proactive monitoring, maintenance, and support for your entire IT infrastructure.",
    features: ["Infrastructure Monitoring", "Help Desk Support", "Patch Management", "Asset Tracking"],
    stat: "99.9%",
    statLabel: "Uptime",
  },
  {
    icon: ShieldCheck,
    title: "Cybersecurity",
    slug: "cybersecurity",
    accentColor: "#0891b2",
    desc: "Multi-layered security solutions to protect your business from evolving cyber threats.",
    features: ["Threat Detection", "Vulnerability Assessment", "Firewall Management", "Incident Response"],
    stat: "500+",
    statLabel: "Threats Blocked",
  },
  {
    icon: Cloud,
    title: "Cloud Computing",
    slug: "cloud-computing",
    accentColor: "#7c3aed",
    desc: "Seamless cloud migration, optimization, and management across AWS, Azure, and GCP.",
    features: ["Cloud Migration", "Cost Optimization", "Multi-Cloud Management", "Backup & DR"],
    stat: "40%",
    statLabel: "Cost Reduction",
  },
  {
    icon: Headphones,
    title: "IT Consulting",
    slug: "it-consulting",
    accentColor: "#2563eb",
    desc: "Strategic technology advisory to align your IT investments with business growth objectives.",
    features: ["Digital Strategy", "Tech Stack Audit", "Vendor Selection", "Roadmap Planning"],
    stat: "3x",
    statLabel: "ROI",
  },
  {
    icon: Headphones,
    title: "Help Desk Support",
    slug: "help-desk",
    accentColor: "#f59e0b",
    desc: "24/7 responsive IT support to resolve technical issues and keep your team productive.",
    features: ["24/7 Support", "Ticket Management", "Remote Assistance", "User Training"],
    stat: "<15min",
    statLabel: "Response Time",
  },
];

export const SUPPLY_SERVICES = [
  {
    icon: Package,
    title: "Office Supplies",
    slug: "office-supplies",
    accentColor: "#0ea5e9",
    desc: "Complete range of office essentials delivered on time with competitive bulk pricing.",
    features: ["Stationery & Supplies", "Tech Accessories", "Furniture Solutions", "Bulk Orders"],
    stat: "35%",
    statLabel: "Savings",
  },
  {
    icon: Coffee,
    title: "Kitchen Pantry",
    slug: "kitchen-pantry",
    accentColor: "#f97316",
    desc: "Premium kitchen supplies to keep your office pantry fully stocked with quality products.",
    features: ["Beverages & Snacks", "Disposables", "Appliances", "Monthly Subscriptions"],
    stat: "2,000+",
    statLabel: "Products",
  },
  {
    icon: Apple,
    title: "Fresh Fruits",
    slug: "fresh-fruits",
    accentColor: "#ef4444",
    desc: "Farm-fresh fruits delivered to your office, promoting healthy eating across your team.",
    features: ["Daily/Weekly Delivery", "Seasonal Varieties", "Organic Options", "Custom Baskets"],
    stat: "100%",
    statLabel: "Organic",
  },
  {
    icon: Shirt,
    title: "Branded Apparel",
    slug: "branded-apparel",
    accentColor: "#6366f1",
    desc: "Corporate branded clothing and uniforms that reflect your company's professional image.",
    features: ["Custom Branding", "Bulk Orders", "Quality Fabrics", "Design Support"],
    stat: "7-Day",
    statLabel: "Delivery",
  },
  {
    icon: Gift,
    title: "Corporate Gifts",
    slug: "corporate-gifts",
    accentColor: "#ec4899",
    desc: "Thoughtfully curated corporate gifts for employees, clients, and special occasions.",
    features: ["Customization", "Premium Packaging", "Bulk Pricing", "Pan-India Delivery"],
    stat: "500+",
    statLabel: "Gift Options",
  },
  {
    icon: UtensilsCrossed,
    title: "Organic Canteen",
    slug: "organic-canteen",
    accentColor: "#14b8a6",
    desc: "Complete canteen management with organic, healthy food options for employee wellness.",
    features: ["Organic Menu", "Nutrition Planning", "Hygiene Standards", "Daily Operations"],
    stat: "4.9/5",
    statLabel: "Rating",
  },
];

export const MANPOWER_SERVICES = [
  {
    icon: Users,
    title: "Permanent Staffing",
    slug: "permanent-staffing",
    accentColor: "#2563eb",
    desc: "End-to-end recruitment for permanent positions across all levels and industries.",
    features: ["Talent Sourcing", "Background Verification", "90-Day Replacement", "Cultural Fit Assessment"],
    stat: "95%",
    statLabel: "Retention Rate",
  },
  {
    icon: ClipboardList,
    title: "Temporary Staffing",
    slug: "temporary-staffing",
    accentColor: "#7c3aed",
    desc: "Flexible temporary workforce solutions to meet seasonal and project-based demands.",
    features: ["Quick Deployment", "Scalable Teams", "Compliance Management", "Performance Tracking"],
    stat: "48h",
    statLabel: "Deployment",
  },
  {
    icon: UserCheck,
    title: "Contract Staffing",
    slug: "contract-staffing",
    accentColor: "#0891b2",
    desc: "Contract hiring for specialized projects with flexible duration and terms.",
    features: ["Contract-to-Hire", "Project Staffing", "Compliance Handled", "Flexible Terms"],
    stat: "500+",
    statLabel: "Active Contracts",
  },
  {
    icon: HardHat,
    title: "Skilled Manpower",
    slug: "skilled-manpower",
    accentColor: "#16a34a",
    desc: "Certified skilled workforce including technicians, operators, and specialized labor.",
    features: ["ITI Certified", "Skilled Technicians", "Quality Inspectors", "Safety Trained"],
    stat: "50K+",
    statLabel: "Skilled Workers",
  },
  {
    icon: HardHat,
    title: "Unskilled Labour",
    slug: "unskilled-labour",
    accentColor: "#ea580c",
    desc: "Reliable unskilled labor supply for manufacturing, construction, and facility operations.",
    features: ["Daily Wage Workers", "Bulk Hiring", "Attendance Management", "Safety Compliance"],
    stat: "1000+",
    statLabel: "Daily Workers",
  },
  {
    icon: Award,
    title: "Executive Search",
    slug: "executive-search",
    accentColor: "#dc2626",
    desc: "C-suite and senior leadership recruitment with comprehensive assessment and vetting.",
    features: ["Confidential Search", "Leadership Assessment", "Industry Network", "Global Reach"],
    stat: "100+",
    statLabel: "C-Suite Placements",
  },
  {
    icon: Building2,
    title: "Facility Management",
    slug: "facility-management",
    accentColor: "#0891b2",
    desc: "Comprehensive facility services — housekeeping, security, maintenance, and landscaping.",
    features: ["Housekeeping", "Security Services", "Maintenance", "Landscaping"],
    stat: "24/7",
    statLabel: "Support",
  },
  {
    icon: Receipt,
    title: "Payroll Management",
    slug: "payroll-management",
    accentColor: "#7c3aed",
    desc: "End-to-end payroll processing, compliance, and employee benefits administration.",
    features: ["Salary Processing", "Tax Deductions", "PF/ESI Management", "Payslip Generation"],
    stat: "100%",
    statLabel: "Compliance",
  },
];

export const WHY_SWITCH = [
  {
    title: "Save Up to 30%",
    stat: "30%",
    statLabel: "Cost Reduction",
    desc: "Reduce vendor management costs with streamlined processes and competitive pricing across services.",
    color: "#10b981",
  },
  {
    title: "Quality Guaranteed",
    stat: "100%",
    statLabel: "Satisfaction",
    desc: "Every service backed by our quality guarantee. Consistent, high-standard deliverables every time.",
    color: "#3b82f6",
  },
  {
    title: "Save Time",
    stat: "10x",
    statLabel: "Faster Onboarding",
    desc: "Consolidate multiple vendors into one reliable partner. One call, one invoice, zero confusion.",
    color: "#f59e0b",
  },
  {
    title: "Full Flexibility",
    stat: "0",
    statLabel: "Lock-in Contracts",
    desc: "Scale services up or down based on your needs. No rigid contracts or long-term commitments.",
    color: "#8b5cf6",
  },
];

export const PARTNER_COMPANIES = [
  "TechNova Solutions", "GreenLeaf Industries", "Sunrise Exports", "BlueSky Corp",
  "Horizon Enterprises", "Pinnacle Ventures", "SwiftBiz Solutions", "Vertex Global",
  "Nexus Technologies", "Summit Industries", "Clarity Consulting", "Apex Traders",
];

export const SERVICES_DROPDOWN = [
  "Compliance Services", "Accounting Services", "GST Filing Services", "Income Tax Filing", "MCA Compliance",
  "IT Services", "Managed IT Services", "Cybersecurity", "Cloud Solutions", "IT Consulting",
  "Business Supplies", "Office Supplies", "Kitchen & Pantry", "Fresh Fruits Supply", "Branded Apparel",
  "Corporate Gifts", "Canteen Setup",
  "Manpower Solutions", "Staffing Solutions", "Payroll Management", "Facility Management", "HR Outsourcing",
];
